module.exports = __webpack_public_path__ + "img/icon-calendario.594e88c2.svg";